export default {"src":"/_next/static/media/reply.fc7abdca.svg","height":9,"width":12,"blurWidth":0,"blurHeight":0};